import { render, staticRenderFns } from "./VeJwKaoshiList.vue?vue&type=template&id=6f47cbc2&scoped=true"
import script from "./VeJwKaoshiList.vue?vue&type=script&lang=js"
export * from "./VeJwKaoshiList.vue?vue&type=script&lang=js"
import style0 from "./VeJwKaoshiList.vue?vue&type=style&index=0&id=6f47cbc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f47cbc2",
  null
  
)

export default component.exports